<template>
  <div>

<ul class="flex flex-wrap justify-center list-reset select-none text-sm lg:text-base">
  <li>
    <a
      class="block cursor-pointer px-2 lg:px-3 py-2"
      :class=" value === 1 ? 'light:text-gray-500 dark:text-gray-600' : 'text-blue-400 hover:text-white hover:bg-blue-500'"
      @click="change(1)"
    >First</a>
  </li>
  <li>
    <a
      class="block cursor-pointer px-2 lg:px-3 py-2 lg:mr-4"
      :class=" value - 1 < 1 ? 'light:text-gray-500 dark:text-gray-600' : 'text-blue-400 hover:text-white hover:bg-blue-500'"
      @click="change(value - 1)"
    >Previous</a>
  </li>

  <li v-for="page in pages" :key="'page-number-' + page">
    <a
      class="block cursor-pointer hover:text-white hover:bg-blue-500 text-blue-400 px-2 lg:px-3 py-2"
      :class="{ 'font-bold bg-theme-darker': page === value }"
      @click="$emit('input', page)"
    >
    {{ page }}
    </a>
  </li>

  <li>
    <a
      class="block cursor-pointer px-2 lg:px-3 py-2 lg:ml-4"
      :class=" value + 1 > lastPage ? 'light:text-gray-500 dark:text-gray-600' : 'text-blue-400 hover:text-white hover:bg-blue-500'"
      @click="change(nextPage)"
    >Next</a>
  </li>
  <li>
    <a
      class="block cursor-pointer hover:text-white hover:bg-blue-500 text-blue-400 px-2 lg:px-3 py-2"
      :class=" value === lastPage ? 'light:text-gray-500 dark:text-gray-600' : 'text-blue-400 hover:text-white hover:bg-blue-500'"
      @click="change(lastPage)"
    >Last</a>
  </li>
</ul>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'list-search',
  props: {
    value: Number,
    totalRows: Number,
    rowsPerPage: Number,
  },
  data() {
    return {
      offset: 4,
      delay: {
        resize: {
          n: null,
          t: 150,
        }
      }
    }
  },
  computed: {
    nextPage() {
      return this.value + 1 > this.lastPage ? this.lastPage : this.value + 1
    },
    lastPage() {
      return Math.ceil(this.totalRows / this.rowsPerPage)
    },
    pages() {
      let from = this.value - this.offset
      if (from < 1) {
        from = 1
      }

      let to = from + (this.offset * 2)
      if (to >= this.lastPage) {
        to = this.lastPage
      }

      let pages = []
      for (let page = from; page <= to; page++) {
        pages.push(page)
      }
      return pages
    },
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    window.addEventListener('resize', this.setOffsetByWindowWidth)
    this.setOffsetByWindowWidth()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setOffsetByWindowWidth)
  },
  methods: {
    setOffsetByWindowWidth() {
      clearTimeout(this.delay.resize.t)
      this.delay.resize.n = setTimeout(() => {
        if (window.innerWidth <= this.config.screenBreakpoints.lg) {
          this.offset = 2
        } else {
          this.offset = 4
        }
      }, this.delay.resize.t)
    },
    change(page) {
      if (page > this.lastPage || page < 1) {
        return false
      }
      this.$emit('input', page)
    },
  }
}
</script>
